import React, { useState } from "react";

export default function StaffSessionLock({ user, resume, logout }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async event => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try { await resume(password); }
    catch (e) { setError(e?.response?.data?.detail || e.message || "Unable to sign in."); }
    finally { setPassword(""); setBusy(false); }
  };
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-100 p-6" role="dialog" aria-modal="true" aria-labelledby="session-lock-title">
    <form onSubmit={submit} className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg">
      <h1 id="session-lock-title" className="text-xl font-bold">Session locked</h1>
      <p className="mt-3">Staff sessions expire after 60 minutes without activity. Sign in again to continue.</p>
      <p className="mt-3 text-sm">Your current page is kept in memory, not saved. Do not refresh or close this tab. Signing out discards unsaved work.</p>
      <label className="mt-4 block">Email<input className="mt-1 w-full rounded border p-2" value={user.email || ""} readOnly autoComplete="username" /></label>
      <label className="mt-3 block">Password<input className="mt-1 w-full rounded border p-2" type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required autoFocus /></label>
      {error && <p role="alert" className="mt-3 text-red-700">{error}</p>}
      <button className="mg-btn-primary mt-4" disabled={busy} type="submit">{busy ? "Signing in…" : "Sign in and continue"}</button>
      <button className="ml-3 underline" type="button" disabled={busy} onClick={() => { if (window.confirm("Sign out and discard unsaved work?")) logout(); }}>Sign out</button>
    </form>
  </div>;
}
